var AnalyticsVersions;
(function (AnalyticsVersions) {
    AnalyticsVersions["Launch"] = "launch";
    AnalyticsVersions["DynamicTagManagement"] = "dtm";
    AnalyticsVersions["Legacy"] = "legacy";
    AnalyticsVersions["WebSdk"] = "web-sdk";
})(AnalyticsVersions || (AnalyticsVersions = {}));
export default AnalyticsVersions;
//# sourceMappingURL=AnalyticsVersions.js.map